import styled, { createGlobalStyle } from "styled-components";

//deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const GlobalStyle = createGlobalStyle`
  em {
    font-style: inherit;
  }
`;

interface CTAProps {
    showSettleBill?: boolean;
    showTurboPayment?: boolean;
}

export const CTAContainer = styled.div<CTAProps>(({ theme, showSettleBill, showTurboPayment }) => ({
    position: "fixed",
    zIndex: 99,
    width: "100%",
    left: 0,
    bottom: 0,
    padding: theme.spacing.medium,
    paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.medium})`,

    ...(showSettleBill && {
        background: theme.colors[theme.colorMode].background_Primary,
        padding: `0px 0px calc(var(--sab, 0px) + ${theme.spacing.medium}) 0px`,
        borderTopLeftRadius: theme.cornerRadius.medium,
        borderTopRightRadius: theme.cornerRadius.medium,
    }),
    "@supports (-webkit-touch-callout: none)": {
        "@supports (padding-bottom: env(safe-area-inset-bottom))": {
            paddingBottom: `calc(${theme.spacing.medium} + (env(safe-area-inset-bottom) / 2))`,
        },
    },
    ...(showTurboPayment && {
        background: theme.colors[theme.colorMode].background_Primary,
        padding: 0,
        borderTopLeftRadius: theme.cornerRadius.small,
        borderTopRightRadius: theme.cornerRadius.small,
        boxShadow: theme.elevation[theme.colorMode].liftedNegative.boxShadow,
    }),
}));

export const ProceedCTA = styled.button(({ theme }) => ({
    width: "100%",
    borderRadius: theme.cornerRadius.medium,
    zIndex: 1000,
    borderColor: theme.colors[theme.colorMode].positive,
    backgroundColor: theme.colors[theme.colorMode].positive,
    elevation: 7,
    shadowRadius: 3,
    borderStyle: "solid",
    height: 58,
    paddingBottom: theme.spacing.medium,
}));

export const ButtonTextContainer = styled.div(({ theme }) => ({
    padding: theme.spacing.small,
    display: "grid",
    justifyContent: "center" /* Centers items horizontally */,
    alignItems: "center" /* Centers items vertically */,
}));

export const Container = styled.div(({ theme }) => ({
    backgroundColor: theme.colors[theme.colorMode].background_Secondary,
    height: "100%",
    paddingTop: 0, // Default for Android
    overflowY: "scroll",
    msOverflowStyle: "none", // IE and Edge
    scrollbarWidth: "none", // Firefox
    WebkitOverflowScrolling: "touch", // Smooth scrolling for iOS
}));

interface IContent {
    addMargin: boolean;
}
export const ContentContainer = styled.div<IContent>(({ theme, addMargin }) => ({
    paddingBottom: addMargin ? 145 : 190,
    minHeight: "100vh",
    backgroundColor: theme.colors[theme.colorMode].background_Secondary,
}));

export const StyledText = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.xxSmall,
}));

export const BillContainer = styled.div(({ theme }) => ({
    marginTop: theme.spacing.large,
}));

export const OneWidgetWrapper = styled.div(({ theme }) => ({
    paddingTop: theme.spacing.medium,
    paddingBottom: theme.spacing.large,
}));

export const CenterContainer = styled.div(({ theme }) => ({
    paddingLeft: theme.spacing.medium,
    paddingRight: theme.spacing.medium,
}));
